// extracted by mini-css-extract-plugin
module.exports = {"main":"NewTag_main__8fEb1","label":"NewTag_label__mACDJ"};